import { createGlobalStyle } from 'styled-components'

export const TooltipStyle = createGlobalStyle`
  .MuiTooltip-popper .MuiTooltip-tooltip {
    width: 368px;
    max-width: 368px;
  }
`
